import { render, staticRenderFns } from "./ReducirVelocidad.vue?vue&type=template&id=2db24c2e&scoped=true&"
import script from "./ReducirVelocidad.vue?vue&type=script&lang=js&"
export * from "./ReducirVelocidad.vue?vue&type=script&lang=js&"
import style0 from "./ReducirVelocidad.vue?vue&type=style&index=0&id=2db24c2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db24c2e",
  null
  
)

export default component.exports